import { ConverterAnalyticsEventType } from '@quicktools/shared-components/services/converter-analytics';
import { AnalyticsGTM } from '@quicktools/shared-components/services/analytics-gtm';
import ReactGA4 from 'react-ga4';

import { TOOL_NAME, VERSION } from '../../configs';

const page_name = 'main';

const TOOL_MAP: { [key: string]: string } = {
  em: 'emojis',
  sy: 'symbols',
  fg: 'font_generator',
};

class Analytics extends AnalyticsGTM {
  event(action: string) {
    this.sendGaEvent(action, {
      page_name,
    });
    this.hjEvent(action);
  }

  pageOpen() {
    this.sendGaEvent(ConverterAnalyticsEventType.PAGE_OPEN, {
      page_name,
      non_interaction: true,
    });
  }

  textBoxClick() {
    this.event('text_box_click');
  }

  textBoxType() {
    this.event('text_box_type');
  }

  symbolCopy(category_name: string, symbol_name: string) {
    this.sendGaEvent('symbol_copy', {
      page_name,
      category_name,
      symbol_name,
    });
  }

  symbolArrayCopy() {
    this.event('symbol_array_copy');
  }

  symbolArrayClear() {
    this.event('symbol_array_clear');
  }

  filterOpen() {
    this.event('filter_open');
  }

  filterApply() {
    this.event('filter_apply');
  }

  toggleClick(name: string) {
    this.sendGaEvent('toggle_click', {
      page_name,
      destination: TOOL_MAP[name],
    });
  }
}

export default new Analytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);
